var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',[_c('Item',{attrs:{"title":"新增客户","content":"本月新增的广告主"},on:{"change":_vm.handleChange,"expand":_vm.handleExpand}}),_c('div',{ref:"newAccount",staticStyle:{"height":"270px","margin-top":"28px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }